import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Tabs, Tab, Typography, withStyles } from '@material-ui/core';
import SectionGrid from '../primitives/SectionGrid';
import { FEDERAL_FILING_STATUSES, FILING_TABS } from '../dashboardConstants';
const styles = theme => ({
  tabs: { ...theme.header.filingTabs },
  tab: { ...theme.header.filingTab },
  filingMain: { ...theme.header.filingMain },
  filingAmended: { ...theme.header.filingAmended },
  filingExtension: { ...theme.header.filingExtension },
  notice: { ...theme.header.filingNotice },
});

const FederalFilingSection = ({ classes, business = false }) => {
  const [filingType, setFilingType] = useState('main');
  const state = useSelector(store => store.dashboardOverview.heroCards);
  const data = state?.data?.[business ? 'filingStatusesCorp' : 'filingStatuses1040'];
  const id = business ? 'business-federal-filings' : 'federal-filings';
  const title = business ? 'Business Fed Returns Submitted' : 'Fed Returns Submitted';
  const filingLabel = FILING_TABS.find(tab => tab.value === filingType).label;
  const unavailable = Boolean(state?.error || (!state?.loading && !data));
  const cards = FEDERAL_FILING_STATUSES.map(status => ({
    key: status.code,
    title: status.title,
    count: data?.[filingType]?.[status.code] || 0,
    entity: business ? 'Business' : 'Individual',
    loading: state?.loading,
    error: unavailable,
    action:
      unavailable || state?.loading || status.code === 'A'
        ? undefined
        : {
            type: 'returns',
            filingType,
            filingLabel,
            filingStatusCode: status.code,
          },
  }));
  // Status.code ='A' correlates to Fed Accepted.
  // We want to prevent this from having an onClick since
  // it is composed of multiple return statuses

  return (
    <SectionGrid
      title={title}
      cards={cards}
      panelId={`${id}-panel`}
      labelledBy={`${id}-${filingType}`}
      headerContent={
        <>
          <Tabs
            value={filingType}
            onChange={(event, value) => setFilingType(value)}
            className={classes.tabs}
            aria-label={`${title} filing type`}
          >
            {FILING_TABS.map(tab => (
              <Tab
                key={tab.value}
                value={tab.value}
                label={tab.label}
                id={`${id}-${tab.value}`}
                aria-controls={`${id}-panel`}
                className={classes.tab}
                classes={{ selected: classes[tab.style] }}
              />
            ))}
          </Tabs>
          {!state?.loading && !state?.error && data?.missing > 0 && (
            <Typography className={classes.notice} role="status">
              {data.missing} {data.missing === 1 ? 'return is' : 'returns are'} not yet included in
              these counts.
            </Typography>
          )}
        </>
      }
    />
  );
};
export default withStyles(styles)(FederalFilingSection);
